import Text from 'components/Text/Text';
import React from 'react';
import classNames from 'classnames';
import DnDList from './components/DnDList/DnDList';
import style from './ChangePositionList.module.scss';

const ChangePositionList: React.FC = () => {
	const categoryHeadingClasses = classNames(style.category, style.heading);
	const categoryTypeHeadingClasses = classNames(style.categoryType, style.heading);
	const restaurantHeadingClasses = classNames(style.restaurant, style.heading);
	const customerHeadingClasses = classNames(style.customer, style.heading);

	return (
		<div className={style.container} data-test="ChangePositionList">
			<div className={style.tableHeaders}>
				<Text
					className={categoryHeadingClasses}
					translationNameSpace="listing"
					translationKey="categoryLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={categoryTypeHeadingClasses}
					translationNameSpace="listing"
					translationKey="categoryTypeLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={restaurantHeadingClasses}
					translationNameSpace="listing"
					translationKey="restaurantLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={customerHeadingClasses}
					translationNameSpace="listing"
					translationKey="customerLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
			</div>
			<DnDList />
		</div>
	);
};

export default ChangePositionList;
